// @writing-suite/compile/screenplay (W5b): screenplays from SuiteCompile/Screenplay.swift: the printed script
// (`screenplayScript`), pagination as screenplay software does it (`scriptLayout`: 54 lines on Letter, 58 on A4,
// headings kept with what follows, (MORE)/(CONT'D), dual dialogue), the Typst source that places every line
// (`screenplayTypst`), and the FDX and Fountain writers.
export {
  addContinueds, BOTTOM_MARGIN, cut, fountainPageCount, LEFT_MARGIN, screenplayScript, scriptLayout, sentenceEnds, speaker, TOP_MARGIN,
  WIDTH, wrap, type Paragraph, type Run, type ScreenplayScript, type ScriptLayout, type ScriptLine, type ScriptPage, type TitleField,
} from './script.ts';
export { markup as screenplayMarkup, screenplayFontFamilies, screenplayPageCount, screenplayTypst, titleLines, type ScreenplayTypstOptions } from './typst.ts';
export { fdxText, writeFDX, writeFountain } from './writers.ts';
export {
  castOf, castPage, continuations, emptyStageScript, printedStageScript, printedStageScriptAsync, sampleOf, stageLayout, stagePageCount,
  stagePageNumber, stageScript, STAGE_COLUMNS, type CastEntry, type StageLayout, type StagePart, type StageScript,
} from './stage.ts';
export { frontPages, stagePageCountOf, stageTypst, stageUKFontFamilies, stageUKPageCount, stageUKSetup, stageUKSource, stageUKTypst, type StageUKSetup } from './stageTypst.ts';
export { stageDocxEntries, writeStageDocx } from './stageDocx.ts';
export { isMusicCue, numbersPage, sing, type SongEntry } from './stage.ts';
export { numberEntry } from './stageTypst.ts';
export {
  isNumberedAct, multicamDocxEntries, multicamLayout, multicamPageCount, multicamPageCountOf, multicamScript, multicamTypst, sceneLetter,
  writeMulticamDocx, type MulticamLayout, type MulticamScene, type MulticamScript,
} from './multicam.ts';
export {
  RADIO_FALLBACKS, radioDocxEntries, radioEstimatedPages, radioPageCount, radioScript, radioSource, radioTypst, writeRadioDocx,
  type RadioScene, type RadioScript,
} from './radio.ts';
